/**
 * The Smart Pen switch (docs/06-UI-SPEC.md §6.3, SRS C5).
 *
 * On by default, and one click from off. A teacher whose handwriting has just been
 * turned into a triangle should not have to find a settings screen to stop it
 * happening again — the switch is in the panel beside the pen that did it.
 *
 * Off means off entirely: no snapping, and no smoothing either. What the hand drew
 * is what stays on the board.
 */

import { useBoardStore } from '../../board/store.js';

export function SmartPenControls() {
  const smartPen = useBoardStore((state) => state.smartPen);
  const setSmartPen = useBoardStore((state) => state.setSmartPen);

  return (
    <section className="flex flex-col gap-2">
      <h3 className="text-sm font-medium text-text-secondary">Smart Pen</h3>
      <label className="flex min-h-touch cursor-pointer items-start gap-3 rounded-md px-1 py-1.5 hover:bg-surface-hover">
        <input
          type="checkbox"
          checked={smartPen}
          onChange={(event) => {
            setSmartPen(event.target.checked);
          }}
          className="mt-0.5 h-5 w-5 shrink-0 accent-primary"
        />
        <span className="flex flex-col">
          <span className="text-sm font-medium text-text-primary">Shapes snap to clean form</span>
          <span className="text-xs text-text-secondary">
            Rough shapes tidy themselves up, and shaky lines are smoothed. Your
            handwriting is left alone either way.
          </span>
        </span>
      </label>
    </section>
  );
}
